import React from "react"
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography, { TypographyProps } from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { motion } from 'framer-motion';
import LinesComponent from './LinesComponent';
import Theme from './Theme';
import PropTypes from "prop-types"


const HelloWorld = (props) => {
  return (
    <Theme>
    <React.Fragment>
       <Grid container component="main" sx={{ height: '100vh' }}>
        <Grid
          size={5}
          item
          sx={{
            background:
              'linear-gradient(211.21deg, #3376C2 29.32%, #2B62A1 95.41%)',
            position: 'relative',
            overflow: 'hidden',
            display: { xs: 'none', md: 'block' }
          }}
        >

          <Box
            position="absolute"
            top={108}
            left={59}
            component={motion.div}
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, type: 'spring', bounce: 0.25 }}
            zIndex={1}
          >
            <img src="/logo-large.png" alt="Contacryto" width={258} height={66} />
            <Typography
            variant="h5"
            mt={4}
            sx={{ color: 'common.white', maxWidth: '30rem' }}
          >
            Simplify and automate cryptocurrency accounting for businesses of all sizes.
          </Typography>
          </Box>


          <Box
            position="absolute"
            right={0}
            bottom={-4}
            component={motion.div}
            initial={{ opacity: 0, scale: 0.9, x: -600, y: 300 }}
            animate={{ opacity: 1, scale: 1, x: 0, y: 0 }}
            transition={{ duration: 1, type: 'spring', bounce: 0.25 }}
          >
          <LinesComponent />
        </Box>
        </Grid>


        <Grid
          size={{ xs: 12, md: 7 }}
          sx={{
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxWidth: '500px',
              width: '100%'
            }}
          >
            <Typography
              color="#3376c2"
              variant="h3"
              fontWeight={700}
              mb={2}
              lineHeight="72px"
              textAlign="center"
            >
              Welcome to
            </Typography>
            <Box width={205} height={177} component="img" src="/contacrypto-logo.png" />

            <Button
              sx={{ mt: 4, maxWidth: '300px', width: '100%' }}
              onClick={() => window.location.href = props.authorization_url}
              size="large"
              variant="outlined"
              startIcon={
                <Box
                  width="25px"
                  height="25px"
                  component="img"
                  src="/xeros-logo.png"
                  alt="xero"
                />
              }
            >
              Log In with Xero
            </Button>
          </Box>
        </Grid>

       </Grid>

    </React.Fragment>
    </Theme>
  )
}

HelloWorld.propTypes = {
  greeting: PropTypes.string
};

export default HelloWorld
